import { useState } from "react";
import { Plus, Trash2, ClipboardList, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import ProgramForm from "@/components/admin/ProgramForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProgramBuilder = ({ programs, exercises, subscribers, onRefresh }) => {
  const [editing, setEditing] = useState(null); // null | {} | program

  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare questa scheda?")) return;
    try {
      await axios.delete(`${API}/programs/${id}`, { withCredentials: true });
      toast.success("Scheda eliminata");
      onRefresh();
    } catch (err) {
      toast.error("Errore nell'eliminazione");
    }
  };

  const exerciseName = (id) => {
    const ex = exercises.find((e) => e.id === id);
    return ex ? `${ex.code} — ${ex.title}` : id;
  };

  return (
    <div data-testid="program-builder">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-serif text-xl text-stone-900">Schede Pazienti ({programs.length})</h2>
        <Button onClick={() => setEditing({})} className="bg-[#2c4c3b] hover:bg-[#1a2e22] text-stone-50 rounded-full" data-testid="new-program-btn">
          <Plus className="w-4 h-4 mr-2" />
          Nuova Scheda
        </Button>
      </div>

      {editing !== null && (
        <ProgramForm
          initial={editing}
          exercises={exercises}
          subscribers={subscribers}
          onClose={() => setEditing(null)}
          onSaved={() => {
            setEditing(null);
            onRefresh();
          }}
        />
      )}

      <div className="space-y-3">
        {programs.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-2xl border border-stone-100">
            <ClipboardList className="w-12 h-12 text-stone-200 mx-auto mb-4" />
            <p className="text-stone-500">Nessuna scheda creata</p>
          </div>
        ) : (
          programs.map((program) => (
            <div key={program.id} className="bg-white rounded-2xl p-5 border border-stone-100" data-testid={`program-row-${program.patient_email}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-stone-900">{program.patient_name}</h3>
                  <p className="text-sm text-stone-500">{program.patient_email}</p>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {program.items.map((item) => (
                      <span key={`${program.id}-${item.exercise_id}`} className="text-[11px] px-2 py-0.5 rounded-full bg-[#e8ece6] text-[#2c4c3b]">
                        {exerciseName(item.exercise_id)}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex gap-1 flex-shrink-0">
                  <button onClick={() => setEditing(program)} className="p-2 text-stone-400 hover:text-[#2c4c3b] hover:bg-[#e8ece6] rounded-lg transition-colors" data-testid={`edit-program-${program.patient_email}`}>
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button onClick={() => handleDelete(program.id)} className="p-2 text-stone-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ProgramBuilder;
